import { render, staticRenderFns } from "./BoardSeasonRanking.vue?vue&type=template&id=0f9d9f16&"
import script from "./BoardSeasonRanking.vue?vue&type=script&lang=js&"
export * from "./BoardSeasonRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports